module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo-1a7775f8d022f3809fe026faae3b156e.svg";